<template>
    <div class="app-container pageallocations">
        <el-row class="toprow is-text-align-right">
            <el-select
                v-model="activeAllocationId"
                placeholder="Select"
                style="width: 300px"
            >
                <el-option
                    v-for="allocation in allocations"
                    :key="'liv' + allocation.id"
                    :label="
                        allocation.annee +
                            '/' +
                            (parseInt(allocation.annee) + 1).toString() +
                            ' - ' +
                            etats[allocation.etat] +
                            ' (' +
                            allocation.max +
                            ' bout.)'
                    "
                    :value="allocation.id"
                />
            </el-select>
            <el-tooltip content="Options allocation">
                <el-link
                    type="success"
                    size="small"
                    icon="el-icon-edit"
                    @click="editAllocation()"
                />
            </el-tooltip>
            <el-tooltip content="Nouvelle allocation">
                <el-link
                    type="success"
                    size="small"
                    icon="el-icon-plus"
                    @click="createAllocation()"
                />
            </el-tooltip>
        </el-row>
        <el-collapse v-model="activeEtat" accordion>
            <el-collapse-item
                v-for="(etat, etatindex) in paniersetats"
                :key="'tableau' + etatindex"
                :title="' Commandes ' + etat"
                :name="etatindex"
            >
                <el-table
                    v-loading="paniersloading"
                    :data="lespaniers(etatindex)"
                    border
                    fit
                    highlight-current-row
                    style="width: 100%"
                >
                    <el-table-column align="left" label="Client" prop="slug">
                        <template slot-scope="scope">
                            <span>{{ scope.row.user }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="left"
                        label="nb cols"
                        width="250"
                        prop="nbcols"
                    >
                        <template slot-scope="scope">
                            <span>{{ scope.row.nbbouteilles }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="left"
                        label="Prix total TTC"
                        width="250"
                        prop="nbcols"
                    >
                        <template slot-scope="scope">
                            <span>{{ scope.row.totalttc }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="left" label="état" prop="etat">
                        <template slot-scope="scope">
                            <span>{{ paniersetat[scope.row.etat] }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" prop="edit" width="50">
                        <template slot-scope="scope">
                            <el-tooltip
                                :content="
                                    'Voir/éditer Allocation de ' + scope.row.user
                                "
                            >
                                <el-link
                                    type="success"
                                    size="small"
                                    icon="el-eye-open"
                                    @click="editPanier(scope.row.user_id)"
                                >
                                    <svg-icon icon-class="eye-open" />
                                </el-link>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                </el-table>
            </el-collapse-item>
        </el-collapse>
        <allocation
            :isvisible="dialogAllocationVisible"
            :allocation="activeAllocation"
            :parent="this"
        />
    </div>
</template>

<script>
import Resource from "@/api/resource";
const allocationResource = new Resource("allocations");
const panierResource = new Resource("paniers");
import allocation from "@/components/Allocation";
import moment from "moment";

export default {
    name: "Allocations",
    components: {
        allocation
    },
    data() {
        return {
            loading: false,
            activeEtat: 'encours',
            paniersloading: false,
            paniers: null,
            allocations: null,
            dialogAllocationVisible: false,
            activeAllocation: {},
            activeAllocationId: null,
            etats: {
                encours: "En cours",
                finalisee: "Finalisée",
                attente: "En attente"
            },
            paniersetat: {
                encours: "En cours",
                valided: "Validée",
                payed: "Payée",
                livred: "Livrée"
            },
            paniersetats: {
                avalider: "À Valider",
                valided: "Validées",
                payed: "Payées",
                livred: "Livrées",
                encours: "En cours"
            }
        };
    },
    created() {},
    activated() {
        // console.log("aaaaaaactivated");
        this.getAllocations();
    },
    watch: {
        activeAllocationId(val) {
            if (val && this.allocations) {
                this.activeAllocation = this.allocations.find(
                    allocation => allocation.id === val
                );
                console.log("cherche paniers ALLOCATION:");
                console.log(this.activeAllocationId);
                console.log(this.activeAllocation);

                this.getPaniers(val);
            }
        }
    },
    methods: {
        lespaniers(etat) {
            if (!this.paniers) {
                return [];
            }
            return this.paniers.filter(panier => panier.etat === etat);
        },
        editPanier(user_id) {
            console.log("editPanier user" + user_id);
            this.$router.push("/allocataires/edit/" + user_id + "#allocations");
        },
        createAllocation() {
            var annee = moment().format("YYYY");
            console.log(annee);
            this.activeAllocation = {
                annee: annee,
                etat: "attente",
                max: 12
            };
            this.dialogAllocationVisible = true;
        },
        editAllocation() {
            console.log("editAllocation");
            this.dialogAllocationVisible = true;
        },
        async getAllocations() {
            console.log("getAllocations");
            this.activeAllocation = null;
            this.activeAllocationId = null;
            this.loading = true;
            const { data } = await allocationResource.list({});
            this.allocations = data;
            this.activeAllocation = data[0];
            this.activeAllocationId = data[0].id;
            this.loading = false;
            console.log(this.allocations);
        },
        async getPaniers(allocation_id) {
            console.log("getPaniers");
            this.paniersloading = true;
            const { data } = await panierResource.list({'allocation_id': allocation_id, 'noadmins': 1});
            this.paniers = data;
            this.paniersloading = false;
            console.log("ALLOCATIONID::");
            console.log(allocation_id);
            console.log("PANIERS::");
            console.log(this.paniers);
        },
        callbackAllocation(reload, allocation) {
            if (reload) {
                this.getAllocations();
            }
            if (allocation) {
                Object.assign(this.activeAllocation, allocation);
            }
        }
    }
};
</script>
